import { getAction, postAction } from './manage.js'

export class RPC {
    //登录
    static login =(params) => postAction('/auth/login', params)
    //获取指定设备状态
    static getMachineStatus =(params) => postAction('/ops/machine/getMachineStatus', params)
    //用户获取指定设备最新宠物姿态
    static getPetStatus =(params) => postAction('/ops/machine/record/pets/attitude/last', params)
    //用户获取指定设备宠物姿态信息列表
    static petsList =(params) => postAction('/ops/machine/record/pets/attitude/list', params)
    //用户获取当前设备最新定位地址
    static machineLocation =(params) => postAction('/ops/machine/location/last', params)
    //通知设备上传定位信息
    static petsGetLocation =(params) => postAction('/ops/machine/aliYun/getLocation', params)

    //获取用户信息
    static getUserInfo =(userId) => getAction(`/ops/user/info/${userId}`)
    //用户编辑
    static userEdit =(params) => postAction(`/ops/user/edit`, params)
    //修改密码
    static updatePwd =(params) => postAction(`/ops/user/updatePwd`, params)
    //注销登录
    static loginOut =(params) => postAction(`/auth/loginOut`, params)

    //根据用户id查询设备列表
    static deviceList =(params) => postAction(`/ops/user/machine/getMachineListByUserId`, params)
    //用户设置默认设备
    static machineDefault =(params) => postAction(`/ops/user/machine/makeDefaultMachine`, params)
    //修改设备上传传感器消息的速度
    static updateSpeed =(params) => postAction(`/ops/machine/aliYun/updateSpeed`, params)
    //用户设备绑定接口
    static machineBind =(params) => postAction(`/ops/user/machine/bind`, params)
    //用户设备解绑接口
    static machineUnBind =(params) => postAction(`/ops/user/machine/unBind`, params)
    //账号注销
    static userDelete =(params) => postAction(`/ops/user/delete`, params)
    
    //修改设备名称
    static updateNickName =(params) => postAction(`/ops/machine/update/nickName`, params)
    //设备开启or关闭
    static machineIsOpen =(params) => postAction(`/ops/user/machine/isOpen`, params)

    //设备模式切换
    static machineSwitch =(params) => postAction(`/ops/machine/aliYun/machine/switch`, params)

    //开启or关闭蜂鸣器
    static buzzerSwitch =(params) => postAction(`/ops/machine/buzzer/switch`, params)
    //开启or关闭GPS
    static gpsSwitch =(params) => postAction(`/ops/machine/gps/switch`, params)

    //根据设备id查询信息
    static machineInfo =(params) => postAction(`/ops/user/machine/getInfoByMachineId`, params)

    //根据设备id获取模型文件
    static getPetModel =(params) => postAction(`/ops/user/machine/getPetModel`, params)

    //用户编辑宠物头像
    static updatePetImage =(params) => postAction(`/ops/user/machine/updatePetImage`, params)

    //宠物头像上传接口
    static uploadPetImageFile =(params) => postAction(`/ops/file/uploadPetImageFile`, params,'multipart/form-data')

    //用户编辑宠物信息
    static updateVariety =(params) => postAction(`/ops/user/machine/updateVariety`, params)

    //宠物品种列表查询
    static getPetList =(params) => postAction(`/ops/variety/getList`, params)

    //用户获取指定设备运动数据
    static motionInformation =(params) => postAction(`/ops/machine/record/pets/motionInformation`, params)

    //用户获取指定设备宠物进食次数 
    static eatCount =(params) => postAction(`/ops/machine/record/pets/eatCount`, params)

    //AI连接接口
    static aiConnect =() => getAction('/ops/ai/connect')

    //发起提问
    static aiSend =(params) => postAction('/ops/ai/send',params)

    //AI断开连接
    static disconnect =() => postAction('/ops/ai/disconnect')

    //用户编辑基础信息
    static userEditInfo =(params) => postAction('/ops/user/edit/info',params)

    //用户获取指定设备宠物运动趋势统计
    static sportsTrends =(params) => postAction('/ops/machine/record/pets/sportsTrends',params)

    //健康记录列表
    static healthRecordList =(params) => postAction('/ops/healthRecord/list',params)

    //新增健康记录
    static healthRecordAdd =(params) => postAction('/ops/healthRecord/add',params)

    //编辑健康记录
    static healthRecordUpdate =(params) => postAction('/ops/healthRecord/update',params)

    //宠物健康相关图片上传接口
    static uploadPetHealthImageFile =(params) => postAction('/ops/file/uploadPetHealthImageFile',params,'multipart/form-data')

    //健康记录详情
    static healthRecordInfo =(healthRecordId) => getAction(`/ops/healthRecord/info/${healthRecordId}`)

    //删除健康记录
    static healthRecordDelete =(params) => postAction('/ops/healthRecord/delete',params)
    
}
